import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import SmoothScroll from "@/components/SmoothScroll";
import PageShell from "@/components/PageShell";

const Home = lazy(() => import("@/pages/Home"));
const Guides = lazy(() => import("@/pages/Guides"));
const GuideDetail = lazy(() => import("@/pages/GuideDetail"));
const CategoriesIndex = lazy(() =>
  import("@/pages/Categories").then((m) => ({ default: m.CategoriesIndex })),
);
const CategoryDetail = lazy(() =>
  import("@/pages/Categories").then((m) => ({ default: m.CategoryDetail })),
);
const ListsIndex = lazy(() => import("@/pages/Lists").then((m) => ({ default: m.ListsIndex })));
const ListDetail = lazy(() => import("@/pages/Lists").then((m) => ({ default: m.ListDetail })));
const About = lazy(() => import("@/pages/About"));
const Policy = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.Policy })));
const Disclosure = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.Disclosure })));
const Privacy = lazy(() => import("@/pages/Privacy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const LegalNotice = lazy(() => import("@/pages/LegalNotice"));
const NotFound = lazy(() => import("@/pages/NotFound"));

/** Height-stable placeholder: keeps the viewport from collapsing while a route chunk loads. */
function RouteFallback() {
  return <div className="min-h-[100svh]" aria-hidden="true" />;
}

/**
 * Nestly App parity: Layout (PageShell) wraps Suspense so CookieBanner / Footer
 * stay mounted while lazy route chunks load.
 */
function App() {
  return (
    <div className="App grain relative">
      <BrowserRouter>
        <SmoothScroll>
          <PageShell>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/guide" element={<Guides />} />
                <Route path="/guida/:slug" element={<GuideDetail />} />
                <Route path="/categorie" element={<CategoriesIndex />} />
                <Route path="/categorie/:slug" element={<CategoryDetail />} />
                <Route path="/liste" element={<ListsIndex />} />
                <Route path="/liste/:slug" element={<ListDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/disclosure" element={<Disclosure />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookie" element={<CookiePolicy />} />
                <Route path="/termini" element={<Terms />} />
                <Route path="/note-legali" element={<LegalNotice />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </PageShell>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
